export default __webpack_public_path__ + "static/car5-fcb59e51b556cc1d824056c6e1ed5873.glb";